<template>
  <section
    id="reviews"
    class="co-bg-striped pb-[4.75rem] pt-12 sm:pb-28 sm:pt-20"
  >
    <div class="co-container-lg mx-auto px-4">
      <h2 class="co-heading-2">
        <slot name="heading">
          相談した方の声
        </slot>
      </h2>

      <!-- 動画 -->
      <div
        id="review-movie"
        class="co-container-xs mx-auto mb-[3.25rem] px-4"
      >
        <h3 class="co-display-9 mb-3 text-center font-bold">
          ＼ 約2分の体験談をチェック ／
        </h3>
        <iframe
          class="aspect-video w-full"
          src="https://www.youtube.com/embed/GkgLDsy1354"
          frameborder="0"
          allowfullscreen="true"
        />
      </div>

      <h3 class="co-display-9 mb-3 text-center font-bold">
        多くの方にご満足いただいております
      </h3>

      <!-- カルーセル -->
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="1"
        :space-between="32"
        :breakpoints="{
          '768': {
            slidesPerView: 2,
          },
          '992': {
            slidesPerView: 3,
          },
        }"
        :pagination="{
          clickable: true,
        }"
      >
        <SwiperSlide
          :key="1"
          class="!h-auto"
        >
          <div
            class="h-full bg-co-gray-50 p-4 shadow md:py-6"
          >
            <div class="mb-3 flex items-start">
              <img
                class="te-img-reviews-twitter mr-3 rounded-full"
                src="~/assets/images/Te/TeCounseling/ReviewsTwitter/sansan_mikan.jpg"
                loading="lazy"
                alt="さんぴ@web制作/デザイン勉強中"
                width="48"
                height="48"
              >
              <div>
                <p class="mb-0 font-bold">
                  さんぴ@web制作/デザイン勉強中
                </p>
                <p class="co-display-14 mb-0 text-co-gray-500">
                  @sansan_mikan
                </p>
              </div>
            </div>
            <p>
              無料体験中の、現役エンジニアによる無料カウンセリングを体験！
              <br>
              初対面で会話とか緊張したけど…！
              <br>
              <span class="co-marker-yellow-1 font-bold">目標達成までの、具体的なステップを丁寧に教えていただき、スクール卒業後にどうするかもイメージ湧きました。</span>（売込みもなかった笑）
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="2"
          class="!h-auto"
        >
          <div
            class="h-full bg-co-gray-50 p-4 shadow md:py-6"
          >
            <div class="mb-3 flex items-start">
              <img
                class="te-img-reviews-twitter mr-3 rounded-full"
                src="~/assets/images/Te/TeCounseling/ReviewsTwitter/NEKOMARUnnn.jpg"
                alt="ねこまる"
                loading="lazy"
                width="48"
                height="48"
              >
              <div>
                <p class="mb-0 font-bold">
                  ねこまる
                </p>
                <p class="co-display-14 mb-0 text-co-gray-500">
                  @NEKOMARUnnn
                </p>
              </div>
            </div>
            <p>
              無料体験レッスン終了！
              <br>
              独学でやってた範囲と同じだったから簡単だったけど、説明がすごくわかりやすくて復習になった。<span class="co-marker-yellow-1 font-bold">こんな感じでレッスンできるなら続けられそう！</span><br>
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="3"
          class="!h-auto"
        >
          <div
            class="h-full bg-co-gray-50 p-4 shadow md:py-6"
          >
            <div class="mb-3 flex items-start">
              <img
                class="te-img-reviews-twitter mr-3 rounded-full"
                src="~/assets/images/Te/TeCounseling/ReviewsTwitter/mikanxmmmi.jpg"
                alt="まい｜Webデザイン"
                loading="lazy"
                width="48"
                height="48"
              >
              <div>
                <p class="mb-0 font-bold">
                  まい｜Webデザイン
                </p>
                <p class="co-display-14 mb-0 text-co-gray-500">
                  @mikanxmmmi
                </p>
              </div>
            </div>
            <p>
              #マンツーマンメンタリング
              <br>
              ニコニコ親切<span class="co-marker-yellow-1 font-bold">エンジニアさんだけど言葉遣いや物腰が丁寧。</span>コミュ力の高さに背筋が伸びた。
              <br>
              #チャットサポート
              <br>
              <span class="co-marker-yellow-1 font-bold">即レス！！！！</span>
              <br>
              PC購入とかWebカメラ不具合とか相談に乗ってもらえてとても助かった。
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="4"
          class="!h-auto"
        >
          <div
            class="h-full bg-co-gray-50 p-4 shadow md:py-6"
          >
            <div class="mb-3 flex items-start">
              <img
                class="te-img-reviews-twitter mr-3 rounded-full"
                src="~/assets/images/Te/TeCounseling/ReviewsTwitter/ashitaore.png"
                alt="明日オレ"
                loading="lazy"
              >
              <div>
                <p class="mb-0 font-bold">
                  明日オレ
                </p>
                <p class="co-display-14 mb-0 text-co-gray-500">
                  @ashitaore
                </p>
              </div>
            </div>
            <p>
              <span class="co-marker-yellow-1 font-bold">メンタリングの体験とても良かったです。</span>
              <br>
              凄い緊張していましたが、担当していただいたメンターさんは優しく詳しく説明していただけました！
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');

.te-img-reviews-twitter {
  width: 2.5rem;
  @media (min-width: 992px) {
    width: 3rem;
  }
}

.co-marker-yellow-1 {
  background: linear-gradient(transparent 70%, #ff3 0);
}
</style>
